import Nav from "@/components/wam/Nav";
import Hero from "@/components/wam/Hero";
import Pain from "@/components/wam/Pain";
import System from "@/components/wam/System";
import Proof from "@/components/wam/Proof";
import Marquee from "@/components/wam/Marquee";
import Deliverables from "@/components/wam/Deliverables";
import Pricing from "@/components/wam/Pricing";
import WhoFor from "@/components/wam/WhoFor";
import About from "@/components/wam/About";
import Faq from "@/components/wam/Faq";
import CtaSection from "@/components/wam/CtaSection";
import Footer from "@/components/wam/Footer";
import Grain from "@/components/wam/Grain";
import Cursor from "@/components/wam/Cursor";
import StickyMobileCta from "@/components/wam/StickyMobileCta";

export default function Landing() {
  return (
    <div className="relative bg-[#070709] text-[#F0ECE4] overflow-x-hidden">
      <Grain />
      <Cursor />
      <Nav />
      <main>
        <Hero />
        <Pain />
        <System />
        <Proof />
        <Marquee />
        <Deliverables />
        <Pricing />
        <WhoFor />
        <About />
        <Faq />
        <CtaSection />
      </main>
      <Footer />
      <StickyMobileCta />
    </div>
  );
}
